import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/bundle/usage-history'

// Modules
import summary from './summary'

const initialState = () => ({
    usageHistory: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        usageHistory: state => state.usageHistory.data,
        pagination: state => state.usageHistory.pagination
    },
    actions: {
        /**
         * @param {{bundleId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listUsageHistory: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listUsageHistory(data)
                const usageHistory = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_USAGE_HISTORY, usageHistory)
                return usageHistory
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetUsageHistory: ({commit}) => commit(mutationTypes.RESET_USAGE_HISTORY)
    },
    modules: {
        summary
    },
    mutations: {
        [mutationTypes.SET_USAGE_HISTORY]: (state, data) => state.usageHistory = data,
        [mutationTypes.RESET_USAGE_HISTORY]: (state) => Object.assign(state, initialState())
    }
}
